"use client"
import type { ReactNode } from "react"
import { useEffect, useState } from "react"
import { cn } from "@local/utils/src/cn"

export const Transition = ({
  show,
  enter,
  enterFrom,
  enterTo,
  leave,
  leaveFrom,
  leaveTo,
  children,
  className,
}: {
  show?: boolean
  enter?: string
  enterFrom?: string
  enterTo?: string
  leave?: string
  leaveFrom?: string
  leaveTo?: string
  children: ReactNode
  className?: string
}) => {
  const [entry, setEntry] = useState(false)
  const [initalState] = useState(show)
  const [showBuffer, setShowBuffer] = useState(show)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional post-render class swap so the CSS transition fires
    setEntry(initalState === show)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  const entryClassNames = cn(
    enter ?? "",
    show ? (enterTo ?? "") : (enterFrom ?? "")
  )
  const leaveClassNames = cn(
    leave ?? "",
    show ? (leaveFrom ?? "") : (leaveTo ?? "")
  )

  return (
    <div
      className={cn(
        className ? className : "",
        entry ? entryClassNames : leaveClassNames
      )}
      onTransitionEnd={() => setShowBuffer(show)}
    >
      {(show || (!show && showBuffer)) && children}
    </div>
  )
}

export default Transition
